module.exports = __webpack_public_path__ + "img/motor_no76.af4c43ff.jpg";